export default __webpack_public_path__ + "static/media/bubble-laptops.4736200c.png";